(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arquixs-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('.encabezado-ea');
  if (!raiz) return;

  var boton = raiz.querySelector('.encabezado-ea__hamburguesa');
  var cerrar = raiz.querySelector('.encabezado-ea__cerrar');
  var overlay = raiz.querySelector('.encabezado-ea__overlay');
  var menu = raiz.querySelector('.encabezado-ea__menu-movil');
  var soportaInert = 'inert' in HTMLElement.prototype;

  function enfocables() {
    if (!menu) return [];
    return Array.prototype.slice.call(
      menu.querySelectorAll('a[href], button:not([disabled])')
    );
  }

  function desactivarFoco(estado) {
    if (soportaInert) {
      if (estado) {
        menu.setAttribute('inert', '');
      } else {
        menu.removeAttribute('inert');
      }
      return;
    }
    enfocables().forEach(function (el) {
      if (estado) {
        el.setAttribute('tabindex', '-1');
      } else {
        el.removeAttribute('tabindex');
      }
    });
    menu.setAttribute('aria-hidden', estado ? 'true' : 'false');
  }

  function abrirMenu() {
    if (!menu || !overlay) return;
    overlay.removeAttribute('hidden');
    menu.classList.add('esta-activo');
    overlay.classList.add('esta-activo');
    desactivarFoco(false);
    if (boton) boton.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (cerrar) cerrar.focus();
  }

  function cerrarMenu(devolverFoco) {
    if (!menu || !overlay) return;
    menu.classList.remove('esta-activo');
    overlay.classList.remove('esta-activo');
    desactivarFoco(true);
    if (boton) boton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!menu.classList.contains('esta-activo')) {
        overlay.setAttribute('hidden', '');
      }
    }, 340);
    if (devolverFoco && boton) boton.focus();
  }

  function atraparFoco(evento) {
    if (evento.key !== 'Tab') return;
    if (!menu.classList.contains('esta-activo')) return;
    var lista = enfocables();
    if (lista.length === 0) return;
    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    if (evento.shiftKey && document.activeElement === primero) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primero.focus();
    }
  }

  if (boton) boton.addEventListener('click', abrirMenu);
  if (cerrar) cerrar.addEventListener('click', function () { cerrarMenu(true); });
  if (overlay) overlay.addEventListener('click', function () { cerrarMenu(true); });

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') {
      if (menu && menu.classList.contains('esta-activo')) cerrarMenu(true);
      return;
    }
    atraparFoco(evento);
  });

  desactivarFoco(true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-filtros-leonisa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cerrarDropdowns(excepto) {
      var abiertos = document.querySelectorAll('.filtros-leonisa__dropdown[data-abierto="true"]');
      abiertos.forEach(function (item) {
        if (item !== excepto) {
          item.setAttribute('data-abierto', 'false');
          var boton = item.querySelector('[data-toggle]');
          if (boton) boton.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function abrirDrawer(raiz) {
      raiz.setAttribute('data-drawer-abierto', 'true');
      document.documentElement.classList.add('filtros-leonisa-bloqueado');
      var disparador = raiz.querySelector('[data-abrir-drawer]');
      if (disparador) disparador.setAttribute('aria-expanded', 'true');
    }

    function cerrarDrawer(raiz) {
      raiz.setAttribute('data-drawer-abierto', 'false');
      document.documentElement.classList.remove('filtros-leonisa-bloqueado');
      var disparador = raiz.querySelector('[data-abrir-drawer]');
      if (disparador) disparador.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (evento) {
      var abrir = evento.target.closest('.filtros-leonisa [data-abrir-drawer]');
      if (abrir) {
        abrirDrawer(abrir.closest('[data-filtros-leonisa]'));
        return;
      }

      var cerrar = evento.target.closest('.filtros-leonisa [data-cerrar-drawer]');
      if (cerrar) {
        cerrarDrawer(cerrar.closest('[data-filtros-leonisa]'));
        return;
      }

      var toggle = evento.target.closest('.filtros-leonisa [data-toggle]');
      if (toggle) {
        var dropdown = toggle.closest('.filtros-leonisa__dropdown');
        var estaAbierto = dropdown.getAttribute('data-abierto') === 'true';
        cerrarDropdowns(dropdown);
        dropdown.setAttribute('data-abierto', estaAbierto ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', estaAbierto ? 'false' : 'true');
        return;
      }

      if (!evento.target.closest('.filtros-leonisa__panel') && !evento.target.closest('.filtros-leonisa__grupo')) {
        cerrarDropdowns(null);
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        cerrarDropdowns(null);
        document.querySelectorAll('[data-filtros-leonisa][data-drawer-abierto="true"]').forEach(cerrarDrawer);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion-destacada-leonisa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalizar(valor) {
      if (valor === null || valor === undefined) return '';
      return String(valor).trim().toLowerCase();
    }

    function obtenerVariantes(card) {
      if (card._variantes) return card._variantes;
      var el = card.querySelector('[data-variantes]');
      try {
        card._variantes = JSON.parse(el.textContent);
      } catch (e) {
        card._variantes = [];
      }
      return card._variantes;
    }

    function coincide(variante, pos, valor) {
      if (pos === 0) return true;
      return normalizar(variante['o' + pos]) === normalizar(valor);
    }

    function colorFiltrable(card) {
      var cp = parseInt(card.getAttribute('data-color-pos') || '0', 10);
      if (cp === 0) return 0;
      var color = card.getAttribute('data-color-seleccionado') || '';
      if (color === '') return 0;
      var hay = obtenerVariantes(card).some(function (v) {
        return coincide(v, cp, color);
      });
      return hay ? cp : 0;
    }

    function variantePara(card) {
      var vs = obtenerVariantes(card);
      var cp = colorFiltrable(card);
      var tp = parseInt(card.getAttribute('data-talla-pos') || '0', 10);
      var color = card.getAttribute('data-color-seleccionado') || '';
      var chip = card.querySelector('.coleccion-leonisa__talla--activa');
      var talla = chip ? chip.getAttribute('data-talla') : '';
      var exacta = vs.find(function (v) {
        return coincide(v, cp, color) && coincide(v, tp, talla);
      });
      if (exacta) return exacta;
      if (tp === 0) return vs.filter(function (v) { return v.disp; })[0] || vs[0];
      return vs.find(function (v) {
        return coincide(v, tp, talla) && v.disp;
      });
    }

    function actualizarTallas(card) {
      var tp = parseInt(card.getAttribute('data-talla-pos') || '0', 10);
      if (tp === 0) return;
      var cp = colorFiltrable(card);
      var color = card.getAttribute('data-color-seleccionado') || '';
      var vs = obtenerVariantes(card);
      var chips = card.querySelectorAll('.coleccion-leonisa__talla');
      var disponibles = [];

      chips.forEach(function (chip) {
        var talla = chip.getAttribute('data-talla');
        var candidatas = vs.filter(function (v) {
          return coincide(v, cp, color) && coincide(v, tp, talla);
        });
        if (candidatas.length === 0) {
          candidatas = vs.filter(function (v) {
            return coincide(v, tp, talla);
          });
        }
        var libre = candidatas.length === 0 || candidatas.some(function (v) { return v.disp; });
        if (libre) disponibles.push(chip);
      });

      if (disponibles.length === 0) {
        chips.forEach(function (chip) { disponibles.push(chip); });
      }

      chips.forEach(function (chip) {
        var libre = disponibles.indexOf(chip) !== -1;
        chip.classList.toggle('coleccion-leonisa__talla--agotada', !libre);
        if (libre) {
          chip.removeAttribute('aria-disabled');
        } else {
          chip.setAttribute('aria-disabled', 'true');
          chip.classList.remove('coleccion-leonisa__talla--activa');
        }
      });
    }

    function reiniciarBoton(card) {
      var boton = card.querySelector('[data-anadir]');
      if (!boton) return;
      var textoEl = boton.querySelector('.coleccion-leonisa__carrito-texto');
      if (textoEl) textoEl.textContent = boton.getAttribute('data-texto');
      var mensaje = card.querySelector('[data-mensaje]');
      if (mensaje) mensaje.textContent = '';
    }

    function cargarSecundaria(card) {
      var img = card.querySelector('.coleccion-leonisa__imagen--secundaria');
      if (!img) return;
      if (img.getAttribute('src')) return;
      var src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
    }

    function activarHover() {
      if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
      document.addEventListener('mouseover', function (evento) {
        var card = evento.target.closest('.coleccion-leonisa__tarjeta');
        if (card) cargarSecundaria(card);
      });
    }

    function activarSwatch(boton) {
      var card = boton.closest('.coleccion-leonisa__tarjeta');
      if (!card) return;

      var imagen = card.querySelector('.coleccion-leonisa__imagen--principal');
      var url = boton.getAttribute('data-imagen');
      if (imagen && url) {
        imagen.setAttribute('src', url);
        imagen.removeAttribute('srcset');
      }

      card.querySelectorAll('.coleccion-leonisa__swatch').forEach(function (item) {
        item.classList.remove('coleccion-leonisa__swatch--activo');
      });
      boton.classList.add('coleccion-leonisa__swatch--activo');

      var color = boton.getAttribute('data-color');
      if (color !== null) {
        card.setAttribute('data-color-seleccionado', color);
        actualizarTallas(card);
      }
      reiniciarBoton(card);
    }

    function seleccionarTalla(chip) {
      var card = chip.closest('.coleccion-leonisa__tarjeta');
      if (!card) return;
      var hayLibres = card.querySelector('.coleccion-leonisa__talla:not(.coleccion-leonisa__talla--agotada)');
      if (chip.classList.contains('coleccion-leonisa__talla--agotada') && hayLibres) return;
      card.querySelectorAll('.coleccion-leonisa__talla').forEach(function (item) {
        item.classList.remove('coleccion-leonisa__talla--activa');
      });
      chip.classList.add('coleccion-leonisa__talla--activa');
      reiniciarBoton(card);
    }

    function actualizarContador() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) {
            var span = el.querySelector('span[aria-hidden="true"]') || el;
            span.textContent = c.item_count;
            el.classList.remove('hidden');
          });
        })
        .catch(function () {});
    }

    function secciones() {
      var lista = [];
      if (document.querySelector('cart-drawer')) lista.push('cart-drawer');
      if (document.querySelector('cart-notification')) lista.push('cart-notification');
      if (document.querySelector('#cart-icon-bubble')) lista.push('cart-icon-bubble');
      return lista;
    }

    function abrirCarrito(datos) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(datos);
        if (typeof drawer.open === 'function') drawer.open();
        return true;
      }
      var noti = document.querySelector('cart-notification');
      if (noti && typeof noti.renderContents === 'function') {
        noti.renderContents(datos);
        return true;
      }
      return false;
    }

    function anadir(boton) {
      var card = boton.closest('.coleccion-leonisa__tarjeta');
      if (!card) return;
      var tp = parseInt(card.getAttribute('data-talla-pos') || '0', 10);
      var chip = card.querySelector('.coleccion-leonisa__talla--activa');
      var mensaje = card.querySelector('[data-mensaje]');
      var hayTallas = card.querySelector('.coleccion-leonisa__talla');

      if (tp > 0 && hayTallas && !chip) {
        if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-selecciona');
        card.querySelectorAll('.coleccion-leonisa__talla:not(.coleccion-leonisa__talla--agotada)').forEach(function (c) {
          c.classList.add('coleccion-leonisa__talla--parpadeo');
          setTimeout(function () { c.classList.remove('coleccion-leonisa__talla--parpadeo'); }, 700);
        });
        return;
      }

      var v = variantePara(card);
      if (!v || !v.disp) {
        if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-agotado');
        return;
      }

      var textoEl = boton.querySelector('.coleccion-leonisa__carrito-texto');
      var original = textoEl ? textoEl.textContent : '';
      boton.disabled = true;

      var cuerpo = { items: [{ id: v.id, quantity: 1 }] };
      var secs = secciones();
      if (secs.length > 0) {
        cuerpo.sections = secs.join(',');
        cuerpo.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return r.json();
        })
        .then(function (datos) {
          if (mensaje) mensaje.textContent = '';
          if (textoEl) textoEl.textContent = boton.getAttribute('data-texto-anadido');
          actualizarContador();
          abrirCarrito(datos);
          setTimeout(function () {
            if (textoEl) textoEl.textContent = original;
            boton.disabled = false;
          }, 1800);
        })
        .catch(function () {
          boton.disabled = false;
          if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-agotado');
        });
    }

    document.addEventListener('click', function (evento) {
      var swatch = evento.target.closest('.coleccion-leonisa__swatch');
      if (swatch) {
        evento.preventDefault();
        activarSwatch(swatch);
        return;
      }

      var chip = evento.target.closest('.coleccion-leonisa__talla');
      if (chip && chip.hasAttribute('data-talla')) {
        evento.preventDefault();
        seleccionarTalla(chip);
        return;
      }

      var anadirBtn = evento.target.closest('[data-anadir]');
      if (anadirBtn && anadirBtn.closest('.coleccion-leonisa__tarjeta')) {
        evento.preventDefault();
        anadir(anadirBtn);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', activarHover);
    } else {
      activarHover();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compra-conjunto-leonisa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatearDinero(centavos, formato) {
      var valor = (centavos / 100.0);
      var partes = valor.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var salida = formato || '${{amount}}';
      salida = salida.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, partes);
      salida = salida.replace(/\{\{\s*amount\s*\}\}/g, partes);
      salida = salida.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, partes);
      salida = salida.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, partes);
      return salida;
    }

    function precioItem(item) {
      var select = item.querySelector('[data-variante]');
      if (select) {
        var opt = select.options[select.selectedIndex];
        if (opt) return parseInt(opt.getAttribute('data-precio') || '0', 10);
      }
      var check = item.querySelector('[data-item]');
      return parseInt(check.getAttribute('data-precio') || '0', 10);
    }

    function varianteItem(item) {
      var select = item.querySelector('[data-variante]');
      if (select) return select.value;
      var check = item.querySelector('[data-item]');
      return check.getAttribute('data-variante-id');
    }

    function iniciar(seccion) {
      if (seccion._iniciada) return;
      seccion._iniciada = true;

      var items = Array.prototype.slice.call(seccion.querySelectorAll('.conjunto-leonisa__item'));
      var boton = seccion.querySelector('[data-anadir]');
      var mensaje = seccion.querySelector('[data-mensaje]');
      var totalOriginalEl = seccion.querySelector('[data-total-original]');
      var totalFinalEl = seccion.querySelector('[data-total-final]');
      var ahorroEl = seccion.querySelector('[data-ahorro]');
      var pct = parseFloat(seccion.getAttribute('data-descuento-pct') || '0');
      var formato = seccion.getAttribute('data-money-format') || '${{amount}}';

      function recalcular() {
        var total = 0;
        var seleccionados = 0;
        items.forEach(function (item) {
          var check = item.querySelector('[data-item]');
          if (check && check.checked && !check.disabled) {
            total += precioItem(item);
            seleccionados += 1;
          }
          var select = item.querySelector('[data-variante]');
          if (select && check) {
            var precioEl = item.querySelector('[data-precio-item]');
            if (precioEl) precioEl.textContent = formatearDinero(precioItem(item), formato);
          }
        });

        var final = total;
        if (pct > 0) {
          final = Math.round(total * (100 - pct) / 100);
        }

        if (totalOriginalEl) totalOriginalEl.textContent = formatearDinero(total, formato);
        if (totalFinalEl) totalFinalEl.textContent = formatearDinero(final, formato);
        if (ahorroEl && pct > 0) {
          var ahorro = total - final;
          ahorroEl.textContent = 'Ahorras ' + formatearDinero(ahorro, formato) + ' (' + pct + '%)';
        }

        if (boton) {
          var textoEl = boton.querySelector('.conjunto-leonisa__boton-texto');
          if (seleccionados === 0) {
            boton.disabled = true;
            if (textoEl) textoEl.textContent = boton.getAttribute('data-texto-vacio');
          } else {
            boton.disabled = false;
            if (textoEl) textoEl.textContent = boton.getAttribute('data-texto');
          }
        }
      }

      items.forEach(function (item) {
        var check = item.querySelector('[data-item]');
        if (check && check.getAttribute('data-bloqueado') === 'true') {
          check.addEventListener('click', function (e) {
            if (!check.checked) e.preventDefault();
          });
        }
        if (check) check.addEventListener('change', recalcular);
        var select = item.querySelector('[data-variante]');
        if (select) select.addEventListener('change', recalcular);
      });

      function secciones() {
        var lista = [];
        if (document.querySelector('cart-drawer')) lista.push('cart-drawer');
        if (document.querySelector('cart-notification')) lista.push('cart-notification');
        if (document.querySelector('#cart-icon-bubble')) lista.push('cart-icon-bubble');
        return lista;
      }

      function abrirCarrito(datos) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(datos);
          if (typeof drawer.open === 'function') drawer.open();
          return true;
        }
        var noti = document.querySelector('cart-notification');
        if (noti && typeof noti.renderContents === 'function') {
          noti.renderContents(datos);
          return true;
        }
        return false;
      }

      if (boton) {
        boton.addEventListener('click', function () {
          var pedido = [];
          items.forEach(function (item) {
            var check = item.querySelector('[data-item]');
            if (check && check.checked && !check.disabled) {
              pedido.push({ id: parseInt(varianteItem(item), 10), quantity: 1 });
            }
          });
          if (pedido.length === 0) return;

          var textoEl = boton.querySelector('.conjunto-leonisa__boton-texto');
          var original = textoEl ? textoEl.textContent : '';
          boton.disabled = true;

          var cuerpo = { items: pedido };
          var modo = seccion.getAttribute('data-modo-descuento');
          var codigo = seccion.getAttribute('data-codigo');
          var redirigir = false;
          if (modo === 'codigo' && codigo) {
            redirigir = true;
          }

          if (!redirigir) {
            var secs = secciones();
            if (secs.length > 0) {
              cuerpo.sections = secs.join(',');
              cuerpo.sections_url = window.location.pathname;
            }
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(cuerpo)
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add');
              return r.json();
            })
            .then(function (datos) {
              if (mensaje) mensaje.textContent = '';
              if (redirigir) {
                window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
                return;
              }
              if (textoEl) textoEl.textContent = boton.getAttribute('data-texto-anadido');
              document.dispatchEvent(new CustomEvent('conjunto-leonisa:anadido'));
              abrirCarrito(datos);
              setTimeout(function () {
                if (textoEl) textoEl.textContent = original;
                boton.disabled = false;
              }, 1800);
            })
            .catch(function () {
              boton.disabled = false;
              if (mensaje) mensaje.textContent = 'No se pudo añadir. Revisa el stock.';
            });
        });
      }

      recalcular();
    }

    function iniciarTodas() {
      document.querySelectorAll('[data-conjunto-leonisa]').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', iniciarTodas);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["estilos-producto-leonisa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activar() {
      if (!document.querySelector('[data-estilos-producto-leonisa]')) return;
      document.body.classList.add('plp-activo');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', activar);
    } else {
      activar();
    }

    document.addEventListener('shopify:section:load', activar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["informacion-producto-leonisa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function raiz(el) {
      return el.closest('[data-producto-leonisa]');
    }

    function variantes(seccion) {
      if (seccion._variantes) return seccion._variantes;
      var el = seccion.querySelector('[data-variantes]');
      try {
        seccion._variantes = JSON.parse(el.textContent);
      } catch (e) {
        seccion._variantes = [];
      }
      return seccion._variantes;
    }

    function normalizar(valor) {
      if (valor === null || valor === undefined) return '';
      return String(valor).trim().toLowerCase();
    }

    function tallaSeleccionada(seccion) {
      var chip = seccion.querySelector('.producto-leonisa__talla--activa');
      if (chip) return chip.getAttribute('data-talla') || '';
      return seccion.getAttribute('data-talla-seleccionada') || '';
    }

    function coincide(variante, pos, valor) {
      if (pos === 0) return true;
      return normalizar(variante['o' + pos]) === normalizar(valor);
    }

    function colorFiltrable(seccion) {
      var cp = parseInt(seccion.getAttribute('data-color-pos') || '0', 10);
      if (cp === 0) return 0;
      var color = seccion.getAttribute('data-color-seleccionado') || '';
      if (color === '') return 0;
      var hay = variantes(seccion).some(function (v) {
        return coincide(v, cp, color);
      });
      return hay ? cp : 0;
    }

    function valoresEn(vs, pos) {
      return vs.map(function (v) { return normalizar(v['o' + pos]); });
    }

    function detectarPosicion(vs, valores) {
      var buscados = valores.map(normalizar).filter(function (x) { return x !== ''; });
      if (buscados.length === 0) return 0;
      var mejor = 0;
      var mejorAciertos = 0;
      [1, 2, 3].forEach(function (pos) {
        var col = valoresEn(vs, pos);
        var aciertos = buscados.filter(function (b) {
          return col.indexOf(b) !== -1;
        }).length;
        if (aciertos > mejorAciertos) {
          mejorAciertos = aciertos;
          mejor = pos;
        }
      });
      return mejor;
    }

    function ajustarPosiciones(seccion) {
      var vs = variantes(seccion);
      if (vs.length === 0) return;

      var tallas = [];
      seccion.querySelectorAll('.producto-leonisa__talla').forEach(function (chip) {
        tallas.push(chip.getAttribute('data-talla'));
      });
      if (tallas.length > 0) {
        var tp = detectarPosicion(vs, tallas);
        if (tp !== 0) seccion.setAttribute('data-talla-pos', tp);
      }

      var colores = [];
      seccion.querySelectorAll('.producto-leonisa__swatch').forEach(function (s) {
        colores.push(s.getAttribute('data-color'));
      });
      if (colores.length > 0) {
        var cp = detectarPosicion(vs, colores);
        if (cp !== 0) seccion.setAttribute('data-color-pos', cp);
      }
    }

    function varianteActual(seccion) {
      var vs = variantes(seccion);
      var cp = colorFiltrable(seccion);
      var tp = parseInt(seccion.getAttribute('data-talla-pos') || '0', 10);
      var color = seccion.getAttribute('data-color-seleccionado') || '';
      var talla = tallaSeleccionada(seccion);
      var encontrada = vs.find(function (v) {
        return coincide(v, cp, color) && coincide(v, tp, talla);
      });
      if (encontrada) return encontrada;
      if (tp === 0) return vs[0];
      return vs.find(function (v) {
        return coincide(v, tp, talla);
      });
    }

    function pintarVariante(seccion) {
      var v = varianteActual(seccion);
      var exacta = true;
      if (!v) {
        exacta = false;
        var lista = variantes(seccion);
        v = lista.filter(function (x) { return x.disp; })[0] || lista[0];
      }
      if (!v) return;

      var precio = seccion.querySelector('[data-precio]');
      if (precio) precio.textContent = v.precio;

      var precioBoton = seccion.querySelectorAll('[data-precio-boton]');
      precioBoton.forEach(function (el) { el.textContent = v.precio; });

      var comparado = seccion.querySelector('[data-comparado]');
      if (comparado) {
        if (v.rebaja) {
          comparado.textContent = v.comparado;
          comparado.removeAttribute('hidden');
        } else {
          comparado.setAttribute('hidden', '');
        }
      }

      var sku = seccion.querySelector('[data-sku]');
      if (sku) sku.textContent = v.sku || '';

      if (exacta && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function actualizarTallas(seccion) {
      var tp = parseInt(seccion.getAttribute('data-talla-pos') || '0', 10);
      if (tp === 0) return;
      var cp = colorFiltrable(seccion);
      var color = seccion.getAttribute('data-color-seleccionado') || '';
      var vs = variantes(seccion);
      var chips = seccion.querySelectorAll('.producto-leonisa__talla');
      var disponibles = [];

      chips.forEach(function (chip) {
        var talla = chip.getAttribute('data-talla');
        var conColor = vs.filter(function (v) {
          return coincide(v, cp, color) && coincide(v, tp, talla);
        });
        var candidatas = conColor;
        if (candidatas.length === 0) {
          candidatas = vs.filter(function (v) {
            return coincide(v, tp, talla);
          });
        }
        var libre = candidatas.length === 0 || candidatas.some(function (v) { return v.disp; });
        if (libre) disponibles.push(chip);
      });

      if (disponibles.length === 0) {
        chips.forEach(function (chip) {
          disponibles.push(chip);
        });
      }

      chips.forEach(function (chip) {
        var libre = disponibles.indexOf(chip) !== -1;
        chip.classList.toggle('producto-leonisa__talla--agotada', !libre);
        if (libre) {
          chip.removeAttribute('aria-disabled');
        } else {
          chip.setAttribute('aria-disabled', 'true');
          chip.classList.remove('producto-leonisa__talla--activa');
        }
      });

      var activa = seccion.querySelector('.producto-leonisa__talla--activa');
      seccion.setAttribute('data-talla-seleccionada', activa ? activa.getAttribute('data-talla') : '');
    }

    function cambiarImagen(seccion, url) {
      if (!url) return;
      var img = seccion.querySelector('[data-imagen-principal]');
      if (!img) return;
      img.setAttribute('src', url);
      img.removeAttribute('srcset');
    }

    function limpiarMensaje(seccion) {
      var mensaje = seccion.querySelector('[data-mensaje]');
      if (mensaje) mensaje.textContent = '';
    }

    function actualizarWpp(seccion) {
      var btn = seccion.querySelector('[data-wpp]');
      if (!btn) return;
      var numero  = btn.getAttribute('data-wpp-numero') || '';
      var titulo  = btn.getAttribute('data-wpp-producto') || '';
      var url     = btn.getAttribute('data-wpp-url') || '';
      var color   = seccion.getAttribute('data-color-seleccionado') || '';
      var talla   = tallaSeleccionada(seccion);
      var v       = varianteActual(seccion);
      var precio  = v ? v.precio : '';

      var partes = ['Hola! Quiero pedir:'];
      partes.push('• Producto: ' + titulo);
      if (color) partes.push('• Color: ' + color);
      if (talla) partes.push('• Talla: ' + talla);
      if (precio) partes.push('• Precio: ' + precio);
      partes.push('• Link: ' + url);

      btn.href = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(partes.join('\n'));
    }

    function elegirColor(boton) {
      var seccion = raiz(boton);
      if (!seccion) return;
      seccion.querySelectorAll('.producto-leonisa__swatch').forEach(function (s) {
        s.classList.remove('producto-leonisa__swatch--activo');
      });
      boton.classList.add('producto-leonisa__swatch--activo');
      seccion.setAttribute('data-color-seleccionado', boton.getAttribute('data-color') || '');

      var nombre = seccion.querySelector('[data-color-nombre]');
      if (nombre) nombre.textContent = boton.getAttribute('data-color') || '';

      cambiarImagen(seccion, boton.getAttribute('data-imagen'));
      actualizarTallas(seccion);
      pintarVariante(seccion);
      limpiarMensaje(seccion);
      actualizarWpp(seccion);
    }

    function elegirTalla(chip) {
      var seccion = raiz(chip);
      if (!seccion) return;
      var hayLibres = seccion.querySelector('.producto-leonisa__talla:not(.producto-leonisa__talla--agotada)');
      if (chip.classList.contains('producto-leonisa__talla--agotada') && hayLibres) return;
      seccion.querySelectorAll('.producto-leonisa__talla').forEach(function (c) {
        c.classList.remove('producto-leonisa__talla--activa');
      });
      chip.classList.add('producto-leonisa__talla--activa');
      seccion.setAttribute('data-talla-seleccionada', chip.getAttribute('data-talla') || '');
      pintarVariante(seccion);
      limpiarMensaje(seccion);
      actualizarWpp(seccion);
    }

    function elegirMiniatura(boton) {
      var seccion = raiz(boton);
      if (!seccion) return;
      seccion.querySelectorAll('[data-miniatura]').forEach(function (m) {
        m.classList.remove('producto-leonisa__miniatura--activa');
      });
      boton.classList.add('producto-leonisa__miniatura--activa');
      cambiarImagen(seccion, boton.getAttribute('data-imagen'));
    }

    function navegarImagen(boton, delta) {
      var seccion = raiz(boton);
      if (!seccion) return;
      var minis = [];
      seccion.querySelectorAll('[data-miniatura]').forEach(function (m) { minis.push(m); });
      if (minis.length === 0) return;
      var actual = 0;
      for (var i = 0; i < minis.length; i++) {
        if (minis[i].classList.contains('producto-leonisa__miniatura--activa')) { actual = i; break; }
      }
      var nuevo = (actual + delta + minis.length) % minis.length;
      elegirMiniatura(minis[nuevo]);
      if (minis[nuevo].scrollIntoView) {
        minis[nuevo].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    function articulos(seccion, v) {
      var cant = parseInt(seccion.getAttribute('data-cantidad') || '1', 10) || 1;
      var lista = [{ id: v.id, quantity: cant }];
      var upsell = seccion.querySelector('[data-upsell]');
      if (upsell && upsell.checked) {
        lista.push({ id: parseInt(upsell.value, 10), quantity: 1 });
      }
      return lista;
    }

    function actualizarCantidadUI(seccion) {
      var cant = parseInt(seccion.getAttribute('data-cantidad') || '1', 10) || 1;
      var valorEl = seccion.querySelector('[data-cantidad-valor]');
      if (valorEl) valorEl.textContent = cant;
      var menosBtn = seccion.querySelector('[data-cantidad-menos]');
      if (menosBtn) menosBtn.disabled = cant <= 1;
    }

    function cambiarCantidad(boton, delta) {
      var seccion = raiz(boton);
      if (!seccion) return;
      var actual = parseInt(seccion.getAttribute('data-cantidad') || '1', 10) || 1;
      var nueva = Math.max(1, actual + delta);
      seccion.setAttribute('data-cantidad', nueva);
      actualizarCantidadUI(seccion);
    }

    function validar(seccion, boton) {
      var mensaje = seccion.querySelector('[data-mensaje]');
      var tp = parseInt(seccion.getAttribute('data-talla-pos') || '0', 10);
      var talla = tallaSeleccionada(seccion);

      if (tp > 0 && talla === '') {
        if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-selecciona');
        seccion.querySelectorAll('.producto-leonisa__talla:not(.producto-leonisa__talla--agotada)').forEach(function (c) {
          c.classList.add('producto-leonisa__talla--parpadeo');
          setTimeout(function () { c.classList.remove('producto-leonisa__talla--parpadeo'); }, 700);
        });
        return null;
      }

      var v = varianteActual(seccion);
      if (!v) {
        var vs = variantes(seccion);
        v = vs.filter(function (x) { return x.disp; })[0];
      }
      if (!v || !v.disp) {
        if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-agotado');
        return null;
      }
      if (mensaje) mensaje.textContent = '';
      return v;
    }

    function actualizarContador() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) {
            var span = el.querySelector('span[aria-hidden="true"]') || el;
            span.textContent = c.item_count;
            el.classList.remove('hidden');
          });
        })
        .catch(function () {});
    }

    function secciones() {
      var lista = [];
      if (document.querySelector('cart-drawer')) lista.push('cart-drawer');
      if (document.querySelector('cart-notification')) lista.push('cart-notification');
      if (document.querySelector('#cart-icon-bubble')) lista.push('cart-icon-bubble');
      return lista;
    }

    function abrirCarrito(datos) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(datos);
        if (typeof drawer.open === 'function') drawer.open();
        return true;
      }

      var noti = document.querySelector('cart-notification');
      if (noti && typeof noti.renderContents === 'function') {
        noti.renderContents(datos);
        return true;
      }

      if (drawer) {
        document.body.classList.add('overflow-hidden');
        drawer.setAttribute('open', '');
        drawer.classList.add('active', 'animate');
        return true;
      }

      return false;
    }

    function enviar(seccion, v, boton, redirigir) {
      boton.disabled = true;
      var cuerpo = { items: articulos(seccion, v) };
      var secs = secciones();
      if (secs.length > 0) {
        cuerpo.sections = secs.join(',');
        cuerpo.sections_url = window.location.pathname;
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return r.json();
        })
        .then(function (datos) {
          if (redirigir) {
            window.location.href = '/checkout';
            return;
          }
          actualizarContador();
          var accion = seccion.getAttribute('data-accion-carrito');
          if (accion === 'pagina') {
            window.location.href = '/cart';
            return;
          }
          if (accion === 'drawer') {
            var abierto = abrirCarrito(datos);
            if (!abierto) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
          }
          boton.disabled = false;
        })
        .catch(function () {
          boton.disabled = false;
          var mensaje = seccion.querySelector('[data-mensaje]');
          if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-agotado');
        });
    }

    function comprar(boton) {
      var seccion = raiz(boton);
      if (!seccion) return;
      var v = validar(seccion, boton);
      if (!v) return;
      enviar(seccion, v, boton, true);
    }

    function anadir(boton) {
      var seccion = raiz(boton);
      if (!seccion) return;
      var v = validar(seccion, boton);
      if (!v) return;
      var textoEl = boton.querySelector('.producto-leonisa__carrito-texto') || boton;
      var original = textoEl.textContent;
      enviar(seccion, v, boton, false).then(function () {
        textoEl.textContent = boton.getAttribute('data-texto-anadido');
        setTimeout(function () { textoEl.textContent = original; }, 1800);
      });
    }

    function abrirGuia(boton) {
      var seccion = raiz(boton);
      if (!seccion) return;
      var modal = seccion.querySelector('[data-modal-guia]');
      if (!modal) return;
      modal.setAttribute('data-abierto', 'true');
      document.documentElement.classList.add('producto-leonisa-bloqueado');
      var cerrar = modal.querySelector('[data-cerrar-guia]');
      if (cerrar) cerrar.focus();
    }

    function cerrarGuia(modal) {
      modal.setAttribute('data-abierto', 'false');
      document.documentElement.classList.remove('producto-leonisa-bloqueado');
    }

    document.addEventListener('click', function (evento) {
      var menosBtn = evento.target.closest('[data-cantidad-menos]');
      if (menosBtn) {
        evento.preventDefault();
        cambiarCantidad(menosBtn, -1);
        return;
      }

      var masBtn = evento.target.closest('[data-cantidad-mas]');
      if (masBtn) {
        evento.preventDefault();
        cambiarCantidad(masBtn, 1);
        return;
      }

      var flechaPrev = evento.target.closest('[data-flecha-prev]');
      if (flechaPrev) {
        evento.preventDefault();
        navegarImagen(flechaPrev, -1);
        return;
      }

      var flechaNext = evento.target.closest('[data-flecha-next]');
      if (flechaNext) {
        evento.preventDefault();
        navegarImagen(flechaNext, 1);
        return;
      }

      var abrirBtn = evento.target.closest('[data-abrir-guia]');
      if (abrirBtn) {
        evento.preventDefault();
        abrirGuia(abrirBtn);
        return;
      }

      var cerrarBtn = evento.target.closest('[data-cerrar-guia]');
      if (cerrarBtn) {
        evento.preventDefault();
        cerrarGuia(cerrarBtn.closest('[data-modal-guia]'));
        return;
      }

      var swatch = evento.target.closest('.producto-leonisa__swatch');
      if (swatch) {
        evento.preventDefault();
        elegirColor(swatch);
        return;
      }

      var chip = evento.target.closest('.producto-leonisa__talla');
      if (chip) {
        evento.preventDefault();
        elegirTalla(chip);
        return;
      }

      var mini = evento.target.closest('[data-miniatura]');
      if (mini) {
        evento.preventDefault();
        elegirMiniatura(mini);
        return;
      }

      var comprarBtn = evento.target.closest('[data-comprar]');
      if (comprarBtn) {
        evento.preventDefault();
        comprar(comprarBtn);
        return;
      }

      var anadirBtn = evento.target.closest('[data-anadir]');
      if (anadirBtn) {
        evento.preventDefault();
        anadir(anadirBtn);
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        document.querySelectorAll('[data-modal-guia][data-abierto="true"]').forEach(cerrarGuia);
      }
    });

    function iniciar() {
      document.querySelectorAll('[data-producto-leonisa]').forEach(function (seccion) {
        ajustarPosiciones(seccion);
        actualizarTallas(seccion);
        pintarVariante(seccion);
        actualizarWpp(seccion);
        seccion.setAttribute('data-cantidad', '1');
        actualizarCantidadUI(seccion);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cargarSecundaria(card) {
      var img = card.querySelector('.rejilla-leonisa__imagen--secundaria');
      if (!img) return;
      if (img.getAttribute('src')) return;
      var src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
    }

    function activarHover() {
      if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
      document.addEventListener('mouseover', function (evento) {
        var card = evento.target.closest('.rejilla-leonisa__tarjeta');
        if (card) cargarSecundaria(card);
      });
    }

    function obtenerVariantes(card) {
      if (card._variantes) return card._variantes;
      var el = card.querySelector('[data-variantes]');
      try {
        card._variantes = JSON.parse(el.textContent);
      } catch (e) {
        card._variantes = [];
      }
      return card._variantes;
    }

    function normalizar(valor) {
      if (valor === null || valor === undefined) return '';
      return String(valor).trim().toLowerCase();
    }

    function coincide(variante, pos, valor) {
      if (pos === 0) return true;
      return normalizar(variante['o' + pos]) === normalizar(valor);
    }

    function colorFiltrable(card) {
      var cp = parseInt(card.getAttribute('data-color-pos') || '0', 10);
      if (cp === 0) return 0;
      var color = card.getAttribute('data-color-seleccionado') || '';
      if (color === '') return 0;
      var hay = obtenerVariantes(card).some(function (v) {
        return coincide(v, cp, color);
      });
      return hay ? cp : 0;
    }

    function variantePara(card) {
      var vs = obtenerVariantes(card);
      var cp = colorFiltrable(card);
      var tp = parseInt(card.getAttribute('data-talla-pos') || '0', 10);
      var color = card.getAttribute('data-color-seleccionado') || '';
      var chip = card.querySelector('.rejilla-leonisa__talla--activa');
      var talla = chip ? chip.getAttribute('data-talla') : '';
      var exacta = vs.find(function (v) {
        return coincide(v, cp, color) && coincide(v, tp, talla);
      });
      if (exacta) return exacta;
      if (tp === 0) return vs[0];
      return vs.find(function (v) {
        return coincide(v, tp, talla) && v.disp;
      });
    }

    function actualizarTallas(card) {
      var tp = parseInt(card.getAttribute('data-talla-pos') || '0', 10);
      if (tp === 0) return;
      var cp = colorFiltrable(card);
      var color = card.getAttribute('data-color-seleccionado') || '';
      var vs = obtenerVariantes(card);
      var chips = card.querySelectorAll('.rejilla-leonisa__talla');
      var disponibles = [];

      chips.forEach(function (chip) {
        var talla = chip.getAttribute('data-talla');
        var candidatas = vs.filter(function (v) {
          return coincide(v, cp, color) && coincide(v, tp, talla);
        });
        if (candidatas.length === 0) {
          candidatas = vs.filter(function (v) {
            return coincide(v, tp, talla);
          });
        }
        var libre = candidatas.length === 0 || candidatas.some(function (v) { return v.disp; });
        if (libre) disponibles.push(chip);
      });

      if (disponibles.length === 0) {
        chips.forEach(function (chip) { disponibles.push(chip); });
      }

      chips.forEach(function (chip) {
        var libre = disponibles.indexOf(chip) !== -1;
        chip.classList.toggle('rejilla-leonisa__talla--agotada', !libre);
        if (libre) {
          chip.removeAttribute('aria-disabled');
        } else {
          chip.setAttribute('aria-disabled', 'true');
          chip.classList.remove('rejilla-leonisa__talla--activa');
        }
      });
    }

    function reiniciarBoton(card) {
      var boton = card.querySelector('[data-anadir]');
      if (!boton) return;
      var textoEl = boton.querySelector('.rejilla-leonisa__carrito-texto');
      if (textoEl) textoEl.textContent = boton.getAttribute('data-texto');
      var mensaje = card.querySelector('[data-mensaje]');
      if (mensaje) mensaje.textContent = '';
    }

    function activarSwatch(boton) {
      var card = boton.closest('.rejilla-leonisa__tarjeta');
      if (!card) return;

      var imagen = card.querySelector('.rejilla-leonisa__imagen--principal');
      var url = boton.getAttribute('data-imagen');
      if (imagen && url) {
        imagen.setAttribute('src', url);
        imagen.removeAttribute('srcset');
      }

      card.querySelectorAll('.rejilla-leonisa__swatch').forEach(function (item) {
        item.classList.remove('rejilla-leonisa__swatch--activo');
      });
      boton.classList.add('rejilla-leonisa__swatch--activo');

      var color = boton.getAttribute('data-color');
      if (color !== null) {
        card.setAttribute('data-color-seleccionado', color);
        actualizarTallas(card);
      }
      reiniciarBoton(card);
    }

    function seleccionarTalla(chip) {
      var card = chip.closest('.rejilla-leonisa__tarjeta');
      if (!card) return;
      var hayLibres = card.querySelector('.rejilla-leonisa__talla:not(.rejilla-leonisa__talla--agotada)');
      if (chip.classList.contains('rejilla-leonisa__talla--agotada') && hayLibres) return;
      card.querySelectorAll('.rejilla-leonisa__talla').forEach(function (item) {
        item.classList.remove('rejilla-leonisa__talla--activa');
      });
      chip.classList.add('rejilla-leonisa__talla--activa');
      reiniciarBoton(card);
    }

    function actualizarContador() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var n = c.item_count;
          document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) {
            var span = el.querySelector('span[aria-hidden="true"]') || el;
            span.textContent = n;
            el.classList.remove('hidden');
          });
        })
        .catch(function () {});
    }

    function secciones() {
      var lista = [];
      if (document.querySelector('cart-drawer')) lista.push('cart-drawer');
      if (document.querySelector('cart-notification')) lista.push('cart-notification');
      if (document.querySelector('#cart-icon-bubble')) lista.push('cart-icon-bubble');
      return lista;
    }

    function abrirCarrito(datos) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(datos);
        if (typeof drawer.open === 'function') drawer.open();
        return true;
      }
      var noti = document.querySelector('cart-notification');
      if (noti && typeof noti.renderContents === 'function') {
        noti.renderContents(datos);
        return true;
      }
      return false;
    }

    function anadir(boton) {
      var card = boton.closest('.rejilla-leonisa__tarjeta');
      if (!card) return;
      var tp = parseInt(card.getAttribute('data-talla-pos') || '0', 10);
      var chip = card.querySelector('.rejilla-leonisa__talla--activa');
      var mensaje = card.querySelector('[data-mensaje]');

      if (tp > 0 && !chip) {
        if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-selecciona');
        card.querySelectorAll('.rejilla-leonisa__talla:not(.rejilla-leonisa__talla--agotada)').forEach(function (c) {
          c.classList.add('rejilla-leonisa__talla--parpadeo');
          setTimeout(function () { c.classList.remove('rejilla-leonisa__talla--parpadeo'); }, 700);
        });
        return;
      }

      var v = variantePara(card);
      if (!v || !v.disp) {
        if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-agotado');
        return;
      }

      var textoEl = boton.querySelector('.rejilla-leonisa__carrito-texto');
      var original = textoEl ? textoEl.textContent : '';
      boton.disabled = true;

      var cuerpo = { items: [{ id: v.id, quantity: 1 }] };
      var secs = secciones();
      if (secs.length > 0) {
        cuerpo.sections = secs.join(',');
        cuerpo.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return r.json();
        })
        .then(function (datos) {
          if (mensaje) mensaje.textContent = '';
          if (boton.getAttribute('data-redirigir') === 'true') {
            window.location.href = '/cart';
            return;
          }
          if (textoEl) textoEl.textContent = boton.getAttribute('data-texto-anadido');
          actualizarContador();
          abrirCarrito(datos);
          document.dispatchEvent(new CustomEvent('rejilla-leonisa:anadido', { detail: { id: v.id } }));
          setTimeout(function () {
            if (textoEl) textoEl.textContent = original;
            boton.disabled = false;
          }, 1800);
        })
        .catch(function () {
          boton.disabled = false;
          if (mensaje) mensaje.textContent = boton.getAttribute('data-texto-agotado');
        });
    }

    function finalizar(seccion) {
      var boton = seccion.querySelector('[data-cargar-mas]');
      if (boton) boton.setAttribute('hidden', '');
      var sentinela = seccion.querySelector('[data-sentinela]');
      if (sentinela && seccion._observador) seccion._observador.unobserve(sentinela);
    }

    function cargarMas(seccion) {
      var grid = seccion.querySelector('.rejilla-leonisa__grid');
      if (!grid) return;
      if (seccion.getAttribute('data-cargando') === 'true') return;
      var actual = parseInt(grid.getAttribute('data-pagina-actual') || '1', 10);
      var total = parseInt(grid.getAttribute('data-total-paginas') || '1', 10);
      if (actual >= total) { finalizar(seccion); return; }

      seccion.setAttribute('data-cargando', 'true');
      var boton = seccion.querySelector('[data-cargar-mas]');
      if (boton) boton.classList.add('rejilla-leonisa__cargar--cargando');
      var siguiente = actual + 1;
      var url = window.location.pathname + '?section_id=' + seccion.getAttribute('data-section-id') + '&page=' + siguiente;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (texto) {
          var doc = new DOMParser().parseFromString(texto, 'text/html');
          var items = doc.querySelectorAll('.rejilla-leonisa__grid > .rejilla-leonisa__item');
          items.forEach(function (it) { grid.appendChild(document.importNode(it, true)); });
          grid.setAttribute('data-pagina-actual', siguiente);
          if (siguiente >= total) finalizar(seccion);
        })
        .catch(function () {})
        .then(function () {
          seccion.setAttribute('data-cargando', 'false');
          if (boton) boton.classList.remove('rejilla-leonisa__cargar--cargando');
        });
    }

    function iniciarSeccion(seccion) {
      if (seccion._iniciada) return;
      seccion._iniciada = true;
      var infinito = seccion.getAttribute('data-scroll-infinito') === 'true';
      var sentinela = seccion.querySelector('[data-sentinela]');
      if (infinito && sentinela && 'IntersectionObserver' in window) {
        seccion._observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) cargarMas(seccion);
          });
        }, { rootMargin: '600px 0px' });
        seccion._observador.observe(sentinela);
      }
    }

    document.addEventListener('click', function (evento) {
      var swatch = evento.target.closest('.rejilla-leonisa__swatch');
      if (swatch) {
        evento.preventDefault();
        activarSwatch(swatch);
        return;
      }

      var chip = evento.target.closest('.rejilla-leonisa__talla');
      if (chip && chip.hasAttribute('data-talla')) {
        evento.preventDefault();
        seleccionarTalla(chip);
        return;
      }

      var anadirBtn = evento.target.closest('[data-anadir]');
      if (anadirBtn) {
        evento.preventDefault();
        anadir(anadirBtn);
        return;
      }

      var cargar = evento.target.closest('[data-cargar-mas]');
      if (cargar) {
        evento.preventDefault();
        cargarMas(cargar.closest('[data-rejilla-leonisa]'));
      }
    });

    function iniciarTodas() {
      activarHover();
      document.querySelectorAll('[data-rejilla-leonisa]').forEach(iniciarSeccion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-rejilla-leonisa]');
      if (seccion) iniciarSeccion(seccion);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-relacionados-leonisa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cargar(seccion) {
      if (seccion._cargada) return;
      seccion._cargada = true;
      var url = seccion.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (texto) {
          var doc = new DOMParser().parseFromString(texto, 'text/html');
          var nuevo = doc.querySelector('[data-relacionados-leonisa] .relacionados-leonisa__contenedor');
          var actual = seccion.querySelector('.relacionados-leonisa__contenedor');
          if (nuevo && actual) {
            actual.innerHTML = nuevo.innerHTML;
          }
        })
        .catch(function () {});
    }

    function iniciar(seccion) {
      if (seccion._iniciada) return;
      seccion._iniciada = true;

      if (!('IntersectionObserver' in window)) {
        cargar(seccion);
        return;
      }

      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            observador.unobserve(entrada.target);
            cargar(entrada.target);
          }
        });
      }, { rootMargin: '400px 0px' });

      observador.observe(seccion);
    }

    function iniciarTodas() {
      document.querySelectorAll('[data-relacionados-leonisa]').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', iniciarTodas);
  })();

  } catch(e) { console.error(e); }
})();
})();
